var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flash-message',{attrs:{"variant":"success"}}),_c('flash-message',{attrs:{"variant":"danger"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }